import _ from 'lodash';
import { roundToDecimals } from './index';

const computeAcceptablePrice = (spotReferencePrice, relativeDeviation, absoluteDeviation, deviationOperator, priceComparator) => {
    const absoluteMinimum = absoluteDeviation ? roundToDecimals(deviationOperator(absoluteDeviation)) : null;
    const relativeMinimum = relativeDeviation ? roundToDecimals(deviationOperator((spotReferencePrice * relativeDeviation) / 100)) : null;
    const acceptablePrice = _.head([absoluteMinimum, relativeMinimum].filter((item) => !_.isNull(item)).sort(priceComparator));
    return _.isUndefined(acceptablePrice) ? null : acceptablePrice;
};

export const computeLowestAcceptablePrice = (spotReferencePrice, relativeDeviation, absoluteDeviation) => {
    let result = null;
    if (spotReferencePrice) {
        result = computeAcceptablePrice(
            spotReferencePrice,
            relativeDeviation,
            absoluteDeviation,
            (value) => (spotReferencePrice - value),
            (a, b) => (a - b),
        );
    }
    return result;
};

export const computeHighestAcceptablePrice = (spotReferencePrice, relativeDeviation, absoluteDeviation, roundUpHighestAcceptablePrice) => {
    let result = null;
    if (spotReferencePrice) {
        result = computeAcceptablePrice(
            spotReferencePrice,
            relativeDeviation,
            absoluteDeviation,
            (value) => (spotReferencePrice + value),
            (a, b) => (b - a),
        );
    }
    if (roundUpHighestAcceptablePrice && result !== null) {
        return Math.ceil(result);
    }
    return result;
};
